import { apiUrl, axiosBlobInstance } from "../axiosInstance";

export const getStateFundBookingReport = (payload) => {
  return axiosBlobInstance({
    method: "POST",
    url: apiUrl.GET_STATE_FUND_BOOKING_REPORTS,
    data: JSON.stringify(payload)
  });
};
